import React from 'react';
import PropTypes from 'prop-types';
import Notebook from '@learningblocks/exp-constants/lib/Images/notebook-icon.svg';
import NotebookHover from '@learningblocks/exp-constants/lib/Images/notebook-icon-hover.svg';
import NotebookCollapse from '@learningblocks/exp-constants/lib/Images/notebook-icon-collapse.svg';
import {Image} from '@learningblocks/storybook-components';
import style from './style.module.scss';

/**
 * DrawerHandle: The handle component for NotebookDrawer
 * Used to collapse and expand Drawer
 */
export function DrawerHandle(props) {
  const [hover, setHover] = React.useState(false);

  const mouseOver = () => setHover(true);
  const mouseOut = () => setHover(false);

  const getHandleIcon = () => {
    if (props.collapsed) return NotebookCollapse;
    else if (hover) return NotebookHover;
    else return Notebook;
  };

  const wrapperClass = () => {
    return `${
      props.collapsed ? style.drawerCollapsed : style.drawerExpanded
    } drawer-handle`;
  };

  const onClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    props.toggleCollapse(!props.collapsed);
  };

  return (
    <span
      className={wrapperClass()}
      onMouseOver={mouseOver}
      onMouseOut={mouseOut}
      onClick={onClick}>
      <Image src={getHandleIcon()} alt='darawer handle icon' />
    </span>
  );
}

DrawerHandle.propTypes = {
  /**
   * Function invoked to collapse or expand NotebookDrawer
   */
  toggleCollapse: PropTypes.func.isRequired,
  /**
   * Boolean specifyin if Drawer is Collapsed
   */
  collapsed: PropTypes.bool.isRequired,
};
